export default "__VITE_ASSET__De4esgpy__"